// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Per-currency initial true-up route.
 *
 * Renders the stepped initial true-up workflow for a single cost currency, keyed by the
 * ISO code in the path (/accounting/initial-true-up/<iso>). Each currency is trued
 * up in its own run.
 */
import { InitialTrueUpWorkflowPage } from '@/accounting/components/initial-true-up-workflow-page';
import { PageContent } from '@/components/page-content';
import { orgDefaultCurrencyCodeSchema } from '@/constants/currency';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/accounting/initial-true-up/$iso')({
  component: InitialTrueUpCurrencyRoute,
  beforeLoad: ({ params }) => {
    // Redirect a currency the app cannot true up back to the board.
    if (
      !orgDefaultCurrencyCodeSchema.safeParse(params.iso.toUpperCase()).success
    ) {
      throw redirect({ to: '/accounting/initial-true-up' });
    }
  },
});

function InitialTrueUpCurrencyRoute() {
  const { iso } = Route.useParams();
  const currency = orgDefaultCurrencyCodeSchema.parse(iso.toUpperCase());

  return (
    <PageContent
      sx={{
        gap: 3,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <InitialTrueUpWorkflowPage currencyCode={currency} />
    </PageContent>
  );
}
